import { styled } from '@mui/material';
import { Theme } from '@mui/material/styles';
import { SxProps } from '@mui/system';

import Box from '@o2/ui/Box';
import MUIModal from '@o2/ui/Modal';

const ModalContent = styled(Box)(({ theme }) => ({
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 800,
  maxWidth: '90vw',
  background: theme.palette.background.paper,
  borderRadius: theme.spacing(1),
  boxShadow: theme.spacing(3),
  overflow: 'hidden',
}));

interface Props {
  children: React.ReactNode;
  open: boolean;
  onClose: () => void;
  sx?: SxProps<Theme>;
}

const Modal = ({ children, open, onClose, sx }: Props) => (
  <MUIModal open={open} onClose={onClose} sx={sx}>
    <ModalContent>{children}</ModalContent>
  </MUIModal>
);

export default Modal;
